import React, { Component } from 'react';
import './ConsentForm.scss';

class ConsentForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      consent_data_processing: false,
      consent_marketing: false,
      consent_reviews: false,
      consent_third_party: false,
      showPrivacyPolicy: false
    };
  }

  handleConsentChange = (field, value) => {
    this.setState({ [field]: value });
    
    // Pass consent data back to parent component
    if (this.props.onConsentChange) {
      this.props.onConsentChange({
        ...this.state,
        [field]: value
      });
    }
  };

  togglePrivacyPolicy = () => {
    this.setState({ showPrivacyPolicy: !this.state.showPrivacyPolicy });
  };

  render() {
    const { required = false } = this.props;
    
    return (
      <div className="gdpr-consent-form">
        <h3>Data Processing Consent</h3>
        <p className="gdpr-info">
          We respect your privacy. Please choose how you'd like us to handle your personal data:
        </p>
        
        <div className="consent-options">
          <div className="consent-item required">
            <label>
              <input
                type="checkbox"
                checked={this.state.consent_data_processing}
                onChange={(e) => this.handleConsentChange('consent_data_processing', e.target.checked)}
                required={required}
              />
              <span className="required-star">*</span>
              I consent to the processing of my personal data for the purpose of managing my booking reservation.
            </label>
            <p className="consent-explanation">
              <strong>Required:</strong> We need this consent to process your booking, send confirmations, and manage your reservation.
            </p>
          </div>

          <div className="consent-item optional">
            <label>
              <input
                type="checkbox"
                checked={this.state.consent_marketing}
                onChange={(e) => this.handleConsentChange('consent_marketing', e.target.checked)}
              />
              I consent to receiving marketing communications and promotional offers via email.
            </label>
            <p className="consent-explanation">
              <strong>Optional:</strong> You can unsubscribe at any time by clicking the unsubscribe link in our emails.
            </p>
          </div>

          <div className="consent-item optional">
            <label>
              <input
                type="checkbox"
                checked={this.state.consent_reviews}
                onChange={(e) => this.handleConsentChange('consent_reviews', e.target.checked)}
              />
              I consent to being contacted for service reviews and feedback (e.g., Trustpilot).
            </label>
            <p className="consent-explanation">
              <strong>Optional:</strong> Help us improve our services by sharing your experience.
            </p>
          </div>

          <div className="consent-item optional">
            <label>
              <input
                type="checkbox"
                checked={this.state.consent_third_party}
                onChange={(e) => this.handleConsentChange('consent_third_party', e.target.checked)}
              />
              I consent to sharing my data with trusted third-party partners for enhanced services.
            </label>
            <p className="consent-explanation">
              <strong>Optional:</strong> Only reputable partners who help us provide better services.
            </p>
          </div>
        </div>

        <div className="gdpr-links">
          <button 
            type="button" 
            className="link-button" 
            onClick={this.togglePrivacyPolicy}
          >
            Read our Privacy Policy
          </button>
          <a href="/data-rights" target="_blank" rel="noopener noreferrer">
            Your Data Rights
          </a>
        </div>

        {this.state.showPrivacyPolicy && (
          <div className="privacy-policy-modal">
            <div className="modal-content">
              <h4>Privacy Policy Summary</h4>
              <p>
                We collect and process your personal data in accordance with GDPR regulations. 
                Your data is used only for the purposes you've consented to and is stored securely.
              </p>
              <p>
                <strong>Your Rights:</strong> You have the right to access, correct, delete, or 
                export your personal data at any time. Contact us at privacy@booklocal.fo for 
                any data-related requests.
              </p>
              <p>
                <strong>Data Retention:</strong> We keep your booking data for 7 years for legal 
                and accounting purposes. Marketing data is kept until you unsubscribe.
              </p>
              <button onClick={this.togglePrivacyPolicy}>Close</button>
            </div>
          </div>
        )}

        <div className="gdpr-footer">
          <small>
            <span className="required-star">*</span> Required for booking processing. 
            All other consents are optional and can be withdrawn at any time.
          </small>
        </div>
      </div>
    );
  }
}

export default ConsentForm;